<template lang="pug">
  validation-observer(ref='validation' tag='form')
    el-card(
      v-if="active != null"
    )
      el-row
        app-opcoes-header-analise.right(
          :idProcesso="idProcesso",
          :protocolo="protocolo"
          :numeroProcesso="numeroProcesso",
          :tipoProcesso="despacho.processo.tipo.codigo",
          :btnSolicitarInformacao="false"
          :btnRetificacao="false"
          :btnNotificarInteressado="false"
        )
      el-steps.margin-top(:active='active', finish-status='success', simple)
        el-step(title='Informar dados')
        el-step(title='Confirmar dados')
      div(v-if="active === 0")
        app-divider.margin-medium-top(
          :label="'PORTARIA DE APROVAÇÃO DE DEMARCAÇÃO E HOMOLOGAÇÃO DE PROCESSO DE REGULARIZAÇÃO FUNDIÁRIA '",
          :showBorder="false",
        )
        el-row.margin-medium-top(:gutter="20")
          el-col(:span="12")
            app-label(
                label="Processo: ",
                :required="false"
              )
            el-input.input(
              v-model='portaria.numeroProcesso',
              :disabled="true"
            )
          el-col(:span="12")
            app-label(
                label="Interessado:",
                :required="false"
              )
            el-input.input(
              v-model='portaria.interessado',
              :disabled="true"
            )
        el-row.margin-medium-top(:gutter="20")
          el-col(:span="6")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(
                label="Municípios: ",
                :required="true"
              )
              el-select.input(
                :class="{'erro' : errors.length}",
                v-model="municipiosPortaria",
                :required="true"
                :multiple="true"
              )
                el-option(
                  v-for='m in municipios',
                  :key='m.id',
                  :label='m.nome',
                  :value='m.id'
                )
              span.help.erro {{ errors[0] }}
          el-col(:span="18")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(
                label="Denominação:",
              )
              el-input.input(
                v-model="portaria.denominacao",
                name='denominacao',
                :class="{'erro' : errors.length}",
              )
              span.help.erro {{ errors[0] }}

        el-row.margin-medium-top(:gutter="20")
          el-col(:span="12")
            app-label(
              label="Colônia: ",
              :required="false"
            )
            el-input.input(
              v-model="portaria.colonia",
              name='colonia',
            )
          el-col(:span="12")
            app-label(
              label="Lote: ",
              :required="false"
            )
            el-input.input(
              v-model="portaria.lote",
              name='lote',
            )
        el-row.margin-medium-top
          el-col(:span="24")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(
                label="Localização: "
              )
              el-input.input(
                :class="{'erro' : errors.length}",
                v-model="portaria.localizacao",
                name='localizacao',
              )
              span.help.erro {{ errors[0] }}
        el-row.margin-medium-top(:gutter="20")
          el-col(:span="8")
            app-label(
              label="Área 1:",
              :required="false"
            )
            app-double-input.input(
              v-model="portaria.area1",
              name='area1',
              :precision="4",
              :showAppend ="true"
            )
          el-col(:span="8")
            app-label(
              label="Área 2:",
              :required="false"
            )
            app-double-input.input(
              v-model="portaria.area2",
              name='area2',
              :precision="4",
              :showAppend ="true"
            )
          el-col(:span="8")
            app-label(
              label="Área 3:",
              :required="false"
            )
            app-double-input.input(
              v-model="portaria.area3",
              name='area3',
              :precision="4",
              :showAppend ="true"
            )
        el-row.margin-medium-top(:gutter="20")
          el-col(:span="8")
            validation-provider(rules="required|notZero", v-slot="{ errors }")
              app-label(
                label="Área Total:",
              )
              app-double-input.input(
                v-model="portaria.areaTotal",
                name='areaTotal',
                :precision="4",
                :showAppend ="true",
                :class="{'erro' : errors.length}"
              )
              span.help.erro {{ errors[0] }}
          el-col(:span="8")
            validation-provider(rules="required|notZero", v-slot="{ errors }")
              app-label(
                label="Área Líquida:",
              )
              app-double-input.input(
                v-model="portaria.areaLiquida",
                name='areaLiquida',
                :precision="4",
                :showAppend ="true",
                :class="{'erro' : errors.length}"
              )
              span.help.erro {{ errors[0] }}
          el-col(:span="8")
            app-label(
              label="Área Deduzida:",
              :required="false",
            )
            app-double-input.input(
              v-model="portaria.areaDeduzida",
              name='areaDeduzida',
              :precision="4",
              :showAppend ="true"
            )
        el-row.margin-medium-top
          validation-provider(rules="required|notZero", v-slot="{ errors }")
            el-col(:span="24")
              app-label(
                label="Perímetro:",
              )
              app-double-input.input(
                :class="{'erro' : errors.length}",
                v-model="portaria.perimetro",
                name='areaTotal',
                :precision="4",
                :showAppend ="true",
                appendText="Metro(s)"
              )
              span.help.erro {{ errors[0] }}
        el-row.margin-medium-top(:gutter="20")
          el-col(:span="8")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(
                label="Declinação magnética:",
              )
              el-input.input(
                :class="{'erro' : errors.length}",
                v-model="portaria.declinacaoMagnetica"
                name='declinacaoMagnetica',
              )
              span.help.erro {{ errors[0] }}
          el-col(:span="8")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(
                label="Data:",
              )
              el-date-picker.input.full-width(
                :class="{'erro' : errors.length}",
                name="data",
                v-model='portaria.data',
                type='month',
                placeholder='Selecione',
                v-bind="$attrs",
                format="MM/yyyy",
              )
              span.help.erro {{ errors[0] }}
          el-col(:span="8")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(
                label="Vértice:",
              )
              el-input.input(
                :class="{'erro' : errors.length}",
                v-model="portaria.vertice",
                maxlength="15",
                name='vertice',
              )
              span.help.erro {{ errors[0] }}
        el-row(:gutter="20")
          el-col
            app-memorial-descritivo(
              @changeMemorial="changeMemorial",
              @changeLimites="changeLimites"
              :memorialSalvo="portaria.memorialDescritivo"
              :limitesSalvo="despacho.limites"
            )
        el-row
          div.buttons-memorial
            el-button.btn(
              type="default"
              @click="cancelar"
            )
              i.fa.fa-times
              | &nbsp Cancelar
            el-button.btn(
              type="success",
              @click="proximo"
            )
              i.fa.fa-chevron-right
              | &nbsp Próximo
      div(v-else)
        div
          div.container(v-if="this.bytes != null")
            h2 Minuta da Portaria
            app-pdf-viewer(:bytes="bytes",nomeDocumento="Minuta da portaria.pdf")
            div.flex-center
              el-button(
                size="small",
                type="success",
                @click="downloadPdf",
              )
                i.fal.fa-file-pdf
                span &nbsp Exportar PDF
          app-radios-tramitacao(
            :radios="radios",
            :isDecisao="isDecisao"
            @changeRadio="changeRadio",
            :portariaComNumero="portaria.numero"
          )
        div.buttons-memorial
          .float-left
            el-button.btn(
              type="default"
              @click="voltar"
            )
              i.fa.fa-chevron-left
              | &nbsp Voltar
            el-button.btn(
              type="default"
              @click="cancelar"
            )
              i.fa.fa-times
              | &nbsp Cancelar
          .float-right
            el-button.btn(
              type="success",
              @click="finalizarPortaria"
            )
              i.fa.fa-check
              | &nbsp Finalizar
</template>

<script>

import { mapActions } from 'vuex'
import axios from '@/utils/api'
import AppDivider from '@/components/AppDivider'
import AppPDFViewer from '@/components/AppPDFViewer'
import acaoProcesso from '@/constants/acaoProcesso'
import AppLabel from '@/components/AppLabel'
import AppNumber from '@/components/AppNumber'
import AppMemorialDescritivo from './components/AppMemorialDescritivo'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import FileHelper from '@/utils/fileHelper'
import AppOpcoesHeaderAnalise from './components/modal/AppOpcoesHeaderAnalise'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
import AppDoubleInput from '@/components/AppDoubleInput'

export default {
  components: {
    AppDivider,
    AppLabel,
    AppMemorialDescritivo,
    AppNumber,
    FileHelper,
    AppPdfViewer: AppPDFViewer,
    AppOpcoesHeaderAnalise,
    AppRadiosTramitacao,
    AppDoubleInput
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    idProcesso: {
      required: true
    },
    protocolo: {
      required: false
    }
  },

  data () {
    return {
      numeroProcesso: '',
      tipoProcesso: '',
      active: null,
      bytes: null,
      despacho: {},
      nomeRazaoSocialInteressado: null,
      areaTotalValidada: false,
      areaLiquidaValidada: false,
      perimetroValidado: false,
      portaria: {
        numero: null,
        interessado: '',
        denominacao: null,
        colonia: null,
        lote: null,
        localizacao: null,
        areaTotal: 0,
        areaLiquida: 0,
        areaDeduzida: 0,
        perimetro: 0,
        declinacaoMagnetica: null,
        data: null,
        vertice: '',
        memorialDescritivo: null
      },
      municipiosPortaria: [],
      municipios: [],
      radios: [],
      isDecisao: false // variavel utilizado para selecionar a decisão de despacho selecionada e enviar para o componente que exibe os radios

    }
  },

  async created () {
    this.radios = await this.tarefa({ processo: this.idProcesso })
    this.radios = this.radios.acoes
    this.municipios = await this.findMunicipiosByEstadoAtual()
    const response = await this.iniciaAnalise({ idProcesso: this.idProcesso, tipoAcao: acaoProcesso.EMITIR_PORTARIA })
    this.numeroProcesso = response.despacho.processo.numeroProcesso
    this.tipoProcesso = response.despacho.processo.tipo.nome
    this.despacho = response.despacho
    if (response.despacho.portaria !== null) {
      this.portaria = response.despacho.portaria
    }
    if (response.despacho.processo && response.despacho.processo.numeroProcesso !== null) {
      this.portaria.numeroProcesso = response.despacho.processo.numeroProcesso
    }
    if (response.despacho.processo && response.despacho.processo.nomeRazaoSocialInteressado !== null) {
      this.portaria.interessado = response.despacho.processo.nomeRazaoSocialInteressado
    }
    this.active = 0

    this.municipiosPortaria = this.despacho.municipios ? this.despacho.municipios.map(mun => mun.id) : []
  },

  methods: {
    ...mapActions({
      iniciaAnalise: 'processo/iniciaAnalise',
      finalizar: 'despacho/finalizar',
      tarefa: 'processo/tarefa',
      findMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtual'
    }),
    changeMemorial (memorial) {
      this.portaria.memorialDescritivo = memorial
    },

    downloadPdf () {
      FileHelper.saveFile(this.bytes, 'minuta da portaria')
    },

    changeLimites (limites) {
      this.despacho.limites = limites
      this.scrollToElement()
    },

    scrollToElement () {
      const el = this.$el.getElementsByClassName('app-limites')[0]

      if (el) {
        el.scrollIntoView()
      }
    },

    async proximo () {
      this.areaTotalValidada = true
      this.areaLiquidaValidada = true
      this.perimetroValidado = true
      const limitesPreenchidos = this.despacho.limites.length > 0
      this.despacho.municipios = this.municipiosPortaria.map(mun => { return { id: mun } })
      const camposValidos = await this.$refs.validation.validate()
      if (camposValidos && limitesPreenchidos) {
        this.despacho.portaria = this.portaria
        axios({
          method: 'post',
          data: this.despacho,
          url: 'despacho/salvar',
          error: true
        }).then(async (response) => {
          this.despacho.id = response.id
          this.bytes = await axios({
            method: 'get',
            url: `despacho/pdf/portaria/${this.despacho.id}`,
            responseType: 'arraybuffer'
          })
          this.active++
        }).catch(error => {
          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            error.message
          )
        })
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, this.$messages.PORTARIA_EMITIDA)
      } else {
        if (this.despacho.limites.length === 0) {
          this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS_PORTARIA)
        } else {
          this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.$messages.ERRO_VALIDACAO_DIRECOES_PORTARIA)
        }
      }
    },

    finalizarPortaria () {
      this.confirmBox(this.$messages.FINALIZAR_PORTARIA_VASIO, this.$messages.TITULO_WARNING,
        async () => {
          this.despacho.textoDespacho = ''
          const res = await this.finalizar(this.despacho)
          if (res && res.proximoSetor && res.proximoSetor === 'DEAF') {
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, this.mensagemAnaliseBemSucedida(res.proximoSetor))
          } else if (this.despacho.acao === 'RETORNO.SISTEMA.ANTERIOR' && (this.despacho.processo.tipo.codigo === 'TEQ' || this.despacho.processo.tipo.codigo === 'PEAEX')) {
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, this.mensagemAnaliseBemSucedida(res.proximoSetor))
          } else if (res.proximoSetor === 'CCAT') {
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, this.$messages.FINALIZAR_PORTARIA_SUCESSO + ' O processo foi encaminhado para emissão de título CCAT')
          } else {
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, this.$messages.FINALIZAR_PORTARIA_SUCESSO)
          }
          this.$router.push({
            name: 'CAIXA_PORTARIA'
          })
        },
        () => { })
    },

    mensagemAnaliseBemSucedida (setor) {
      if (setor && setor !== '') {
        if (setor.includes('_')) {
          setor = setor.replace(/_/g, '/')
        }
        return `Análise finalizada. Processo enviado para o setor ${setor}.`
      } else {
        return 'Análise finalizada.'
      }
    },

    cancelar () {
      this.confirmBox(this.$messages.CANCELAR_PORTARIA_VASIO, this.$messages.TITULO_WARNING,
        () => {
          this.$router.back()
        },
        () => { })
    },

    voltar () {
      this.active--
    },

    changeRadio (value) {
      this.despacho.acao = value.acao
    }
  }
}
</script>

<style scoped lang="scss">
.full-width {
  width: -webkit-fill-available;
}

.margin-medium-top {
  margin-top: 20px;
}

.tamanho {
  background: red;
}

.margin {
  margin-top: 5px;
  margin-bottom: 19px;
}

.teste {
  border: solid 1px red;
}

.buttons-memorial {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

.link {
  cursor: pointer;
  display: flex;
  text-align: center;
  padding-top: 15px;
  color: #424242;
}

.btn {
  padding: 8px;
  margin-top: 1vh;
  margin-bottom: 1vh;
}

.flex-center {
  display: flex;
  justify-content: center;
}

.width {
  width: 150px;
}

.oi {
  display: flex;
}

.buton-help {
  margin-top: -17px;
  color: #424242;
}

.float-left {
  float: left;
}

.container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
}

#pdf {
  height: 550px !important;
}

.right {
  float: right;
}

.margin-top {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/Portaria.vue